/* ═══════════════════════════════════════════════════════════════
   PiARIS — Product Lockup
   The Pi logo + "ARIS" text wordmark.
   Two sizes (tiny, small) and white-mode for use on gradient backgrounds.
   © 2026 Pi Consultants · pi-consulting.us
   ═══════════════════════════════════════════════════════════════ */
import React from "react";
import { PI_LOGO } from "../constants";

var E = React.createElement;

/** ProductLockup — Pi logo + ARIS text.
    Props:
      size:  "tiny" (20px logo / 11px text) | "small" (26px logo / 14px text) — default "small"
      white: boolean — invert logo + use white text (for dark/gradient backgrounds)
      ariaLabel: optional override (default "PiARIS") */
function ProductLockup(p) {
  var size = p.size || "small";
  var white = !!p.white;
  var sizes = {
    tiny:  { logo: 20, text: 11, overlap: -6 },
    small: { logo: 26, text: 14, overlap: -8 }
  };
  var s = sizes[size] || sizes.small;
  var textColor = white ? "#FFFFFF" : "#0F172A";
  var logoFilter = "none";
  /* The lockup is a link to the site root — clicking the Pi+ARIS mark
     anywhere takes you home. */
  return E("a", {
    href: "/",
    "aria-label": p.ariaLabel || "PiARIS home",
    title: "Home",
    style: {
      display: "inline-flex",
      alignItems: "center",
      lineHeight: 1,
      textDecoration: "none",
      color: "inherit",
      cursor: "pointer"
    }
  },
    E("img", {
      src: PI_LOGO,
      alt: "",
      "aria-hidden": "true",
      style: {
        height: s.logo,
        width: "auto",
        objectFit: "contain",
        filter: logoFilter,
        transition: "filter .2s",
        marginRight: s.overlap
      }
    }),
    E("span", {
      style: {
        fontSize: s.text,
        fontWeight: 900,
        color: textColor,
        letterSpacing: "-0.3px"
      }
    }, "ARIS")
  );
}

export { ProductLockup };
